<div class="grid grid-cols-12 my-20">
  <div class="col-start-2 col-span-10">
    <h1 class="self-stretch text-center justify-start text-gray-900 text-4xl font-extrabold font-['Inter'] leading-[54px]">
      Política de Cancelamento e Renovação Automática - Casato Brasil
    </h1>
    <p class="text-center justify-start text-gray-500 text-xl font-normal font-['Inter'] leading-loose">
      Última atualização: 6 de maio de 2026
    </p>

    <div class="self-stretch justify-start mt-20 text-gray-500 text-base font-normal font-['Inter'] leading-normal">
      <section class="mt-6">
        <h2 class="font-bold">1. Planos e Renovação Automática</h2>
        <p class="mt-1">A Casato Brasil oferece planos de assinatura com cobrança mensal ou anual, conforme informado no momento da contratação.</p>
        <p class="mt-1">Todos os planos possuem renovação automática ao final de cada ciclo contratado, até que o usuário realize o cancelamento.</p>
        <p class="mt-1">Ao término de cada período vigente, uma nova cobrança será realizada utilizando o método de pagamento cadastrado, pelo valor então aplicável e conforme as condições vigentes no momento da renovação.</p>
        <p class="mt-1">Ao contratar um plano, o usuário autoriza expressamente a cobrança recorrente correspondente à assinatura escolhida.</p>
      </section>

      <section class="mt-6">
        <h2 class="font-bold">2. Cancelamento da Renovação</h2>
        <p class="mt-1">O usuário poderá cancelar a renovação automática a qualquer momento por meio da área da conta ou pelos canais oficiais de atendimento disponibilizados pela Plataforma.</p>
        <p class="mt-1">O cancelamento:</p>
        <ul class="mt-1 list-disc pl-6">
          <li>impede novas cobranças futuras após o período já pago</li>
          <li>não interrompe imediatamente o acesso ao serviço contratado</li>
          <li>mantém o acesso ativo até o término do ciclo vigente, salvo exceções legais ou operacionais aplicáveis</li>
        </ul>
        <p class="mt-1">Para evitar a cobrança do próximo ciclo, o cancelamento deverá ser realizado antes da data prevista de renovação.</p>
        <p class="mt-1">Se o cancelamento ocorrer após o processamento da renovação, a cobrança já efetivada poderá permanecer válida para o período correspondente, observada a legislação aplicável.</p>
      </section>

      <section class="mt-6">
        <h2 class="font-bold">3. Reembolsos</h2>
        <p class="mt-1">Salvo quando exigido por lei aplicável ou expressamente previsto em oferta específica, valores já pagos não são automaticamente reembolsáveis, total ou parcialmente, em razão de cancelamento durante o período vigente.</p>
        <p class="mt-1">Pedidos excepcionais poderão ser analisados individualmente, sem criação de precedente para casos futuros.</p>
      </section>

      <section class="mt-6">
        <h2 class="font-bold">4. Período de Teste Gratuito</h2>
        <p class="mt-1">Quando aplicável, a Plataforma poderá oferecer período de teste gratuito por tempo determinado.</p>
        <p class="mt-1">Salvo indicação diversa no momento da adesão, o período de teste será contado em tempo corrido a partir da confirmação da inscrição ou ativação da conta.</p>
        <p class="mt-1">Para fins ilustrativos, um teste grátis de 7 dias iniciado em uma segunda-feira às 10:00 será encerrado no sábado seguinte às 10:00, considerado o fuso horário informado no momento da contratação ou, na ausência de indicação, o fuso horário aplicável ao usuário.</p>
        <p class="mt-1">A duração do teste gratuito, bem como a data e horário previstos para encerramento, serão informados no momento da adesão e poderão também constar na área da conta do usuário.</p>
        <p class="mt-1">Encerrado o período gratuito, a assinatura será convertida automaticamente em plano pago, utilizando o método de pagamento informado, salvo cancelamento realizado antes do término do teste.</p>
        <p class="mt-1">A Casato poderá limitar testes gratuitos por usuário, método de pagamento, dispositivo ou outros critérios razoáveis de prevenção a abuso.</p>
      </section>

      <section class="mt-6">
        <h2 class="font-bold">5. Atualizações de Preço</h2>
        <p class="mt-1">Os valores dos planos poderão ser atualizados periodicamente.</p>
        <p class="mt-1">Quando aplicável, alterações relevantes para assinaturas recorrentes poderão ser comunicadas previamente ao usuário antes da próxima renovação.</p>
        <p class="mt-1">Caso o usuário não concorde com as novas condições, poderá cancelar a renovação antes do próximo ciclo.</p>
      </section>

      <section class="mt-6">
        <h2 class="font-bold">6. Falhas de Pagamento</h2>
        <p class="mt-1">Caso a cobrança não seja autorizada, recusada ou não processada pelo provedor de pagamento, a Casato poderá:</p>
        <ul class="mt-1 list-disc pl-6">
          <li>suspender benefícios vinculados à assinatura</li>
          <li>solicitar atualização do método de pagamento</li>
          <li>restringir acesso a funcionalidades pagas</li>
          <li>cancelar a assinatura após tentativas razoáveis de cobrança</li>
        </ul>
      </section>

      <section class="mt-6">
        <h2 class="font-bold">7. Chargebacks e Contestação Indevida</h2>
        <p class="mt-1">Em caso de contestação de cobrança considerada indevida após contratação regular do serviço, a Casato poderá revisar, suspender ou encerrar a conta, observadas as medidas cabíveis e a legislação aplicável.</p>
      </section>

      <section class="mt-6">
        <h2 class="font-bold">8. Disposições Gerais</h2>
        <p class="mt-1">Esta Política deve ser lida em conjunto com os Termos de Uso e a Política de Privacidade da Plataforma.</p>
        <p class="mt-1">O uso continuado da Plataforma após renovação implica continuidade da relação contratual conforme condições vigentes no momento da renovação.</p>
      </section>

      <section class="mt-6">
        <h2 class="font-bold">9. Contato</h2>
        <p class="mt-1">Para dúvidas relacionadas a assinaturas, cancelamento ou cobrança:</p>
        <p class="mt-1">
          <a href="mailto:contato&#64;casatobrasil.com.br" class="text-blue-600 hover:underline">contato&#64;casatobrasil.com.br</a>
        </p>
      </section>
    </div>
  </div>
</div>
